import { NavLink as RouterNavLink, NavLinkProps } from "react-router-dom";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";

interface NavLinkCompatProps extends Omit<NavLinkProps, "className"> {
  className?: string;
  activeClassName?: string;
  pendingClassName?: string;
}

const NavLink = forwardRef<HTMLAnchorElement, NavLinkCompatProps>(
  ({ className, activeClassName, pendingClassName, to, ...props }, ref) => {
    return (
      <RouterNavLink
        ref={ref}
        to={to}
        className={({ isActive, isPending }) =>
          cn(
            "relative px-3 py-2 text-sm font-medium transition-all duration-300",
            "hover:text-primary",
            "after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2",
            "after:w-0 after:h-0.5 after:bg-gradient-gold after:transition-all after:duration-300",
            "hover:after:w-full",
            isActive ? "text-primary after:w-full" : "text-foreground/80",
            className,
            isActive && activeClassName,
            isPending && pendingClassName
          )
        }
        {...props}
      />
    );
  },
);

NavLink.displayName = "NavLink";

export { NavLink };
